<template>
  <div class="projectEvad">
    <div class="basic">
      <div class="title">招标方评价</div>
      <div>
        <span class="icon_time"></span>
        <span class="text">{{ companyData.finishTime }}</span>
      </div>
    </div>
    <div class="basic">
      <div class="textTitle">项目名称</div>
      <div class="text van-multi-ellipsis--l2">{{ companyData.projectName }}</div>
      <div class="textTitle">项目介绍</div>
      <div class="text">{{ companyData.intro }}</div>
    </div>
    <div class="basic">
      <div class="textTitle">项目名称</div>
      <div class="text van-multi-ellipsis--l2">{{ companyData.projectName }}</div>
      <div class="textTitle">项目介绍</div>
      <div class="text">{{ companyData.intro }}</div>
    </div>
    <div class="basic" v-for="(item, index) in companyData.userList" :key="index">
      <div class="name">{{ item.name }}</div>
      <div class="textBox">
        <span class="icon_gongzhong"></span>
        <span class="title">工种</span>
        <span class="typeWorks">{{ item.typeWorks }}</span>
      </div>
      <div class="textBox">
        <span class="icon_yinghangka"></span>
        <span class="title">银行卡</span>
        <span class="cardNum">{{ item.cardNum }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { workerAssessInfo } from '@api/information'

export default {
  name: 'projectEvad',
  data () {
    return {
      companyData: {}
    }
  },
  created () {
    this.workerAssessInfo()
  },
  methods: {
    workerAssessInfo () {
      workerAssessInfo({
        projectId: 1
      }).then(res => {
        if (res.data.code === 200) {
          this.companyData = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

.projectEvad {
  .basic {
    padding-top: 10px;
  }

  .evaluateTitle {
    @include add_size($font_size_17);
    color: #000000;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .text {
    @include add_size($font_size_15);
    color: #999;
    margin-left: 5px;
  }

  .name {
    @include add_size($font_size_17);
    color: #000000;
    margin-bottom: 5px;
  }

  .title {
    font-weight: 400;
  }

  .scoreStyle {
    vertical-align: sub;
  }
}
</style>
